module.exports = __webpack_public_path__ + "static/media/odd-paywall-logo.205c75b0.png";